import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllMarkupPrices = async () => {
  try {
    const res = await request.get(Constants.get_all_markup_api_url);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
export const addMarkUp = async (data) => {
  try {
    const res = await request.post(Constants.add_markup_api_url, data);
    if (res) {
      return res;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
export const deleteMarkupPrice = async (id) => {
  try {
    const res = await request.delete(`${Constants.delete_markup_api_url}${id}`);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
export const updateMarkUp = async (data, id) => {
  try {
    const res = await request.patch(
      `${Constants.update_markup_api_url}/${id}`,
      data
    );
    if (res) {
      return res.data;
    }
  } catch (e) {
    // toast.error(e.message);
    throw e;
  }
};
